var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEksPpcIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.6 30.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,20.5c0,1.8-1.4,3.2-3.2,3.2c-1.8,0-3.2-1.4-3.2-3.2c0-1.4,0.9-2.6,2.2-3.1v3c0,0.6,0.5,1.1,1.1,1.1s1.1-0.5,1.1-1.1v-3 C13.1,17.9,14,19.1,14,20.5z M21.6,1.1v28c0,0.6-0.5,1.1-1.1,1.1H1.1c-0.6,0-1.1-0.5-1.1-1.1v-28C0,0.5,0.5,0,1.1,0h19.4 C21.1,0,21.6,0.5,21.6,1.1z M16.2,20.5c0-2.6-1.8-4.8-4.3-5.3V14c0-0.6-0.5-1.1-1.1-1.1S9.7,13.4,9.7,14v1.2 c-2.9,0.6-4.8,3.4-4.2,6.4c0.6,2.9,3.4,4.8,6.4,4.2C14.4,25.3,16.2,23,16.2,20.5z M16.2,9.7c0-0.6-0.5-1.1-1.1-1.1H6.5 c-0.6,0-1.1,0.5-1.1,1.1s0.5,1.1,1.1,1.1h8.6C15.7,10.8,16.2,10.3,16.2,9.7z M16.2,5.4c0-0.6-0.5-1.1-1.1-1.1H6.5 c-0.6,0-1.1,0.5-1.1,1.1s0.5,1.1,1.1,1.1h8.6C15.7,6.5,16.2,6,16.2,5.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEksPpcIcon);
export default __webpack_public_path__ + "static/media/eks-ppc-icon.5972d062002531dcc7a8832396d98ad3.svg";
export { ForwardRef as ReactComponent };